<template>
	<div class="tpl gift-exchange-wrap">
		<mt-header title="礼物提现" fixed>
			<router-link :to="{name:'my-gifts'}" slot="left">
				<mt-button icon="back"></mt-button>
			</router-link>
			<mt-button slot="right" @click.native="showAlert=1">提现须知</mt-button>
		</mt-header>
		<div class="top-banner">
			<img src="../../assets/img/mine/center_gift_banner_99.png" alt="">
		</div>
		<div class="form-wrap">
			<p class="title">兑换信息填写</p>
			<div class="form-list">
				<ul>
					<li>
						<span class="name">兑换数量</span>
						<span class="value">
							<span class="add" @click="addNum"><img src="../../assets/img/mine/center_gift_ic_add.png" alt=""></span>
						<input class="nums" type="number" v-model="exchangeNum">
						<span class="add" @click="delNum"><img src="../../assets/img/mine/center_gift_ic_little.png" alt=""></span>
						</span>
					</li>
				</ul>
			</div>
		</div>
		<div class="form-submit">
			<div class="form-price">
				<p>扣除后到账金额：<span class="num-name">￥</span><span class="num">{{price*exchangeNum*0.6}}</span></p>
				<p class="tip">礼物提现到平台扣取40%费用(其中包含个人意外所得税20%)</p>
			</div>
			<div class="form-btn">
				<button>立即提现</button>
			</div>
		</div>
		<common-alert v-if="showAlert" @hideAlert="hideAlert">
			<p slot="title" class="title">{{alertInfo.title}}</p>
			<div class="content" slot="content" v-html="alertInfo.text"></div>
		</common-alert>
	</div>
</template>

<script>
	import CommonAlert from "../Common/CommonAlert"
	export default {
		name: "gift-cash",
		components:{
			CommonAlert,
		},
		data() {
			return {
				uid: "",
				gid:"",		//礼物id
			  	maxNum:"",	//可兑换的最大数量
			  	price:"",	//礼物单价
			  	integral:"",	//礼物积分
			  	exchangeNum:1,	//兑换的数量
			  	showAlert:0,
				alertInfo:{
					title:"兑换须知？",
					text:"<p>&nbsp;1.红包金额需要输入支付宝账号和支付宝姓名<br/>2.红包领取将收取2%的服务费<br/>3.红包提现讲于7-15个工作日内到账，节假日顺延<br/>4.提现流程：点“我的”进入“我的礼物”选择相对应的礼物，点击“去提现”；提现信息填写完整后点击“立即提现到钱包”，平台会及时将您操作的金额提现到“我的钱包”内。可通过“我的钱包”将“我的可提现”的金额提现到支付宝账户<br/>5.注意事项：1、已进行实名认证的账户，方可提现成功。<br/>2、实名制认证账户提现限额为单笔1万，单月5万，实名认证无限额限制。</p>"
				},
			}
		},
		created() {
			console.log(this.$route.query)
			this.uid = this.$store.state.UserId; //获取当前用户的id
			this.$store.commit("changeTabChoosed", "mine");
			this.$store.commit("changeTabBarShow", false);

			this.gid = this.$route.query.gid;
			this.maxNum = this.$route.query.num;
			this.giftType = this.$route.query.type;
			this.price = this.$route.query.price;
	  		this.integral = this.$route.query.integral;
		},
		watch: {
			provId(n, o) {
				this.getAddressList(n, 2);
			},
			cityId(n, o) {
				this.getAddressList(n, 3);
			},
		},
		methods: {
			addNum() {
				if(this.exchangeNum < this.maxNum) {
					this.exchangeNum++;
				} else {
					this.exchangeNum = this.maxNum;
					this.$toast({
						message: "没那么多了~",
						position: "bottom",
						duration: 3000
					})
				}
			},
			delNum() {
				if(this.exchangeNum > 1) {
					this.exchangeNum--;
				} else {
					this.exchangeNum = 1;
					this.$toast({
						message: "不能再减了~",
						position: "bottom",
						duration: 3000
					})
				}
			},
			hideAlert(){
				this.showAlert = 0
			},
		}
	}
</script>

<style scoped>
	>>>.mint-button-text{
		color: #5415F9;
	}
	.gift-exchange-wrap {
		padding-top: 2.5rem;
		padding-bottom: 3.5rem;
	}
	
	.top-banner img {
		width: 100%;
	}
	
	.form-wrap {
		background: #fff;
	}
	
	.form-wrap .title {
		font-size: 1rem;
		color: #282828;
		font-weight: bold;
		line-height: 1.5rem;
		padding: 0.5rem 1rem;
	}
	
	.form-list li {
		padding: 0.6rem 1rem;
		border-top: 1px solid #f3f3f3;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	
	.form-list li .name {
		font-size: 0.8rem;
		color: #282828;
		width: 3.6rem;
		align-self: flex-start;
		padding: 0.4rem 0;
	}
	
	.form-list li:first-of-type input.nums {
		width: 2.5rem;
		height: 1.8rem;
		text-align: center;
		border: 0;
		outline: 0;
		border-left: 1px solid #4E05FF;
		border-right: 1px solid #4E05FF;
		color: #4E05FF;
	}
	
	.form-list li img {
		width: 0.8rem;
	}
	
	.form-list li:first-of-type .value {
		display: flex;
		justify-content: center;
		align-items: center;
		border: 1px solid #4E05FF;
		border-radius: 2rem;
		padding: 0 0.2rem;
		flex: 0;
	}
	
	.form-list li .value span {
		padding: 0 0.5rem;
	}
	
	.form-list li .value span:active {
		opacity: 0.7;
	}
	
	.form-list li .value {
		flex: 1;
	}
	
	.form-list li .value.add {
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	
	.form-list li .value.add>div {
		width: 30%;
		position: relative;
	}
	
	.form-list li .add-list {
		position: absolute;
		font-size: 0.8rem;
		color: #7b7b7b;
		background: #fff;
		text-align: center;
		width: 100%;
		border: 1px solid #f3f3f3;
		top: 100%;
		left: 0;
		max-height: 13.65rem;
		overflow-y: scroll;
		z-index: 10;
	}
	
	.form-list li .add-list p {
		line-height: 1.2rem;
		padding: 0.5rem 0;
		border-bottom: 1px solid #f3f3f3;
	}
	
	.form-list li .add-list p:active {
		background: #fafafa;
	}
	
	.form-list li .value.add>div input {
		width: 100%;
		text-align: left;
	}
	
	.form-list li .value input {
		font-size: 0.8rem;
		width: 100%;
		height: 2rem;
		padding: 0 0.5rem;
		border: 0;
		outline: 0;
		background: none;
	}
	
	.form-list li .value textarea {
		font-size: 0.8rem;
		width: 100%;
		height: 4rem;
		padding: 0.2rem 0.5rem;
		line-height: 1.5rem;
		border: 0;
		outline: 0;
		background: none;
	}
	
	.form-list li:last-of-type .name {
		width: auto;
	}
	
	.form-list li:last-of-type .value {
		flex: 0;
	}
	
	.mint-switch-input:checked+.mint-switch-core {
		border-color: #5415F9;
		background-color: #5415F9;
		opacity: 0.3;
	}
	
	.form-submit {
		display: flex;
		justify-content: space-between;
		align-items: center;
		position: fixed;
		width: 100%;
		bottom: 0;
		left: 0;
		background: #fff
	}
	
	.form-submit button {
		background: linear-gradient(108deg, rgba(84, 21, 249, 0.4) 0%, rgba(84, 21, 249, 0.7) 100%);
		color: #fff;
		font-size: 0.9rem;
		padding: 1rem 1.5rem;
		border: 0;
		outline: 0;
	}
	
	.form-submit .form-price {
		padding-left: 1rem;
		font-size: 0.9rem;
		color: #282828;
	}
	
	.form-submit .form-price .num {
		font-size: 1.5rem;
		color: #5415F9;
		font-weight: bold;
	}
	
	.form-submit .form-price .num-name {
		font-size: 0.5rem;
		color: #7b7b7b;
	}
	
	.form-submit .form-price .tip {
		font-size: 0.5rem;
		color: #7b7b7b;
	}
</style>


// WEBPACK FOOTER //
// src/components/Mine/GiftCash.vue